import api_base, { serializeParams } from '@/api/base';
import { UsersTableParams } from '@/views/users';
import { User, UserInfo } from '@/views/users/data/schema';
import { cleanupObject } from '@/utils/cleanup';
import { AuthUser } from '@/stores/authStore';

interface UserList {
  next: number | null
  previous: number | null
  results: User[],
  count: number
}

export const get_users = async (params: UsersTableParams | null = null): Promise<UserList> => {
  const response = await api_base.get(
    '/api/v1/user/list?include_role_object',
    {
      params: { ...params },
      paramsSerializer: params => serializeParams(params)
    }
  );
  return response.data;
};

interface AddUser {
  name: string | null
  username: string | null
  email: string | null
  is_active: boolean | null
  role: number | null
  is_admin: boolean | null
}

export const add_user = async (body: Partial<AddUser>): Promise<void> => {
  await api_base.post(
    '/api/v1/user/create',
    body,
  );
};

export const update_user = async (id: string, body: Partial<AddUser>, profile: boolean = false): Promise<AuthUser> => {
  const cleanedBody = cleanupObject(body);
  const response = await api_base.patch(
    profile ? '/api/v1/user/profile/update' : '/api/v1/user/update/' + id,
    cleanedBody,
  );
  return response.data as AuthUser;
};

interface UserPassReset {
  password: string
}

export const reset_pass_user = async (id: string): Promise<UserPassReset> => {
  const response = await api_base.get(
    '/api/v1/user/password/reset/' + id
  )
  
  return response.data;
};

export const remove_user = async (id: string): Promise<void> => {
  await api_base.delete(
    '/api/v1/user/remove/' + id
  )
}

interface UniqueUsername {
  taken: boolean
}

export const check_username_unique = async (username: string): Promise<boolean> => {
  try {
    const response = await api_base.get(
      '/api/v1/user/username/taken/' + username
    )
    const resp: UniqueUsername = response.data
    return !resp.taken;
  } catch (_) {
    return true;
  }

}

export const change_password = async (old_password: string, password: string): Promise<void> => {
  await api_base.post(
    '/api/v1/user/password/change',
    { old_password, password }
  )
}

export const get_user_by_id = async (id: string): Promise<UserInfo> => {
  const response = await api_base.get(`/api/v1/user/${id}?include_role_object`);
  return response.data as User; 
};

export const set_user_language = async (language: 'ar' | 'fr'): Promise<void> => {
  await api_base.post('/api/v1/user/language/set', { language });
};

export const get_user_language = async (): Promise<{ language: 'ar' | 'fr' }> => {
  const response = await api_base.get('/api/v1/user/language/set');
  return response.data;
};


export const get_user_onboarding = async (): Promise<string[]> => {
  const response = await api_base.get('/api/v1/user/onboarding');
  return response.data;
};

export const complete_onboarding_step = async (stepId: string): Promise<void> => {
  await api_base.post('/api/v1/user/onboarding/complete', { step_id: stepId });
};

export const reset_onboarding_step = async (stepId?: string): Promise<void> => {
  await api_base.post('/api/v1/user/onboarding/reset', { step_id: stepId });
};